/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { FocusLock } from '@bingads-webui-react/focus-lock';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';

export const FocusLockBackboneInstanceWrapper = ({
  focusLockProps, instance, eventHandlers, managed,
}) => (
  <FocusLock {...focusLockProps}>
    <BackboneInstanceWrapper
      instance={instance}
      eventHandlers={eventHandlers}
      managed={managed}
    />
  </FocusLock>);

FocusLockBackboneInstanceWrapper.propTypes = {
  focusLockProps: PropTypes.object,
  instance: PropTypes.shape({
    $el: PropTypes.object.isRequired,
    render: PropTypes.func.isRequired,
    off: PropTypes.func.isRequired,
    once: PropTypes.func.isRequired,
    on: PropTypes.func.isRequired,
  }).isRequired,
  eventHandlers: PropTypes.shape({
    once: PropTypes.objectOf(PropTypes.func),
    on: PropTypes.objectOf(PropTypes.func),
  }),
  managed: PropTypes.bool,
};

FocusLockBackboneInstanceWrapper.defaultProps = {
  focusLockProps: {},
  eventHandlers: {
    once: {},
    on: {},
  },
  managed: false,
};
